const firebaseConfig = {
  apiKey: 'AIzaSyB_nZMZY6NXAX0WucBDDS9KDnNgFGwWAAc',
  authDomain: 'manycontent-v2-prod.firebaseapp.com',
  databaseURL: 'https://manycontent-v2-prod.firebaseio.com',
  projectId: 'manycontent-v2-prod',
  storageBucket: 'manycontent-v2-prod.appspot.com',
  messagingSenderId: '325770769601',
  appId: '1:325770769601:web:30644e92394d7949'
}

export default firebaseConfig
